import React from 'react';
import cn from 'classnames';
import {FieldArray, useField} from 'formik';
import IconInfo from '../../components/icon/IconInfo';
import Tooltip from '../Tooltip';
import Tags from '@yaireo/tagify/dist/react.tagify';
import '@yaireo/tagify/dist/tagify.css';
import {createUseStyles} from 'react-jss';

type Props = {
  className?: string
  label?: string
  value?: string
  name: string
  id: string
  tooltip?: React.ReactNode
  placeholder?: string
  type?: string
};

export default function TagInput({
                                   id, label, value, className, tooltip, ...props
                                 }: Props) {
  const [field, meta] = useField(props);

  const styles = tagStyle();

  return (
    <>
      <FieldArray name={id}>
        {({push, remove, form}) => (
          <>
            <label htmlFor={id} className="block">
              {label}
              {tooltip &&
                <>
                  <Tooltip content={tooltip}
                           label={`${id}_label_tip`} className="pl-0.5">
                    <IconInfo className="text-gray-dark "/>
                  </Tooltip>
                </>
              }
            </label>
            <div className={cn(className, 'mt-2 w-full')}>
              <Tags value={form.initialValues[id]}
                    onAdd={(e) => push(e.detail.data?.value)}
                    onRemove={(e) => e.detail.index !== undefined && remove(e.detail.index)}
                    className={cn(styles.tag, 'py-2 focus:border-blue-focus block w-full border-gray border rounded-md')}/>
              {meta.error && meta.touched &&
                <div className="text-xs text-red mt-1 ml-2">{meta.error}</div>
              }
            </div>
          </>
        )}
      </FieldArray>
    </>
  );
}

const tagStyle = createUseStyles({
  tag: {
    '--tag-bg': '#CBE3FF',
    '--tag-hover': '#367CCE',
    '--tags-border-color': '#BEC7CE',
    '--tag-text-color--edit': '#111',
    '--tag-remove-bg': 'var(--tag-hover)',
    '--tag-pad': '.3em .3em',
    '--tag-inset-shadow-size': '1.35em',
    '--tag-remove-btn-bg--hover': 'black',
    '--tag-remove-btn-color': '#367CCE',
    '--tags-focus-border-color': '#4A90E2',
    padding: '2px 0'
  }
});
